import { CommonModule } from '@angular/common'
import { AfterViewChecked, Component, ElementRef, Input, ViewChild } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { AngularMaterialsModules } from '../../../module/materials.module'
import { AiAgentService } from '../../../service/ai/ai-agent.service'
import { Agent } from '../models/agent.models'

@Component({
  selector: 'ddc-agent-chat',
  templateUrl: './ddc-agent-chat.component.html',
  styleUrls: ['./ddc-agent-chat.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, AngularMaterialsModules],
})
export class DdcAgentChatComponent implements AfterViewChecked {
  @Input() agent!: Agent
  @Input() theme: string = 'light-theme'

  @ViewChild('chatScroll') chatScroll!: ElementRef<HTMLDivElement>

  messageText = ''
  private shouldScroll = false

  constructor(private agentService: AiAgentService) {}

  send(): void {
    const text = this.messageText.trim()
    if (!text || !this.agent) return
    this.agentService.sendMessage(this.agent.id, text).subscribe()
    this.messageText = ''
    this.shouldScroll = true
  }

  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      this.send()
    }
  }

  ngAfterViewChecked(): void {
    if (this.shouldScroll && this.chatScroll) {
      this.chatScroll.nativeElement.scrollTop = this.chatScroll.nativeElement.scrollHeight
      this.shouldScroll = false
    }
  }
}
